// extracted by mini-css-extract-plugin
export var container = "_6m-0";
export var disabled = "_6m-4";
export var fullWidth = "_6m-3";
export var lined = "_6m-1";
export var selected = "_6m-5";
export var tab = "_6m-2";